// src/services/websocketManager.js

let socket = null;
let listeners = new Set();
let closeTimer = null;
let intentionalClose = false;
let activeUrl = null;

function ensureSocket(url) {
  activeUrl = url;

  // If we already have a socket that is usable, keep it
  if (
    socket &&
    (socket.readyState === WebSocket.OPEN ||
      socket.readyState === WebSocket.CONNECTING)
  ) {
    return socket;
  }

  intentionalClose = false;
  socket = new WebSocket(url);

  socket.onmessage = (event) => {
    for (const fn of listeners) fn(event);
  };

  socket.onerror = (e) => {
    if (!intentionalClose) {
      console.error("❌ [WebSocket] Error:", e);
    }
  };

  socket.onclose = (e) => {
    if (!intentionalClose) {
      console.warn(
        `⚠️ [WebSocket] Disconnected code=${e.code} reason=${e.reason} clean=${e.wasClean}`
      );
    }
    socket = null;
  };

  return socket;
}

// --- Primary API (new name) ---
export function addWebSocketListener(url, handler) {
  listeners.add(handler);

  // Cancel pending close (React unmount/remount churn)
  if (closeTimer) {
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  ensureSocket(url);
}

// --- Compatibility API (old name) ---
export function startWebSocket(url, handler) {
  return addWebSocketListener(url, handler);
}

export function removeWebSocketListener(handler) {
  listeners.delete(handler);

  if (listeners.size === 0 && socket) {
    // Delay close to survive rapid mount/unmount cycles
    closeTimer = setTimeout(() => {
      if (!socket) return;

      // Don't close while connecting (prevents "closed before established")
      if (socket.readyState === WebSocket.CONNECTING) return;

      intentionalClose = true;
      socket.close(1000, "no listeners");
    }, 300);
  }
}

// --- Compatibility API (old name) ---
export function stopWebSocket(handler) {
  return removeWebSocketListener(handler);
}
